/**
 * Returns true on iPhone, iPod or iPad — including iPad in desktop mode,
 * which reports a macOS user-agent but has maxTouchPoints > 1.
 */
export function isIOS(): boolean {
  const ua = navigator.userAgent;
  if (/iPhone|iPod|iPad/.test(ua)) return true;
  // iPad in desktop mode reports "Macintosh" but exposes touch points
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return true;
  return false;
}

/**
 * Returns true on Android devices.
 */
export function isAndroidPlatform(): boolean {
  return /Android/.test(navigator.userAgent);
}

/**
 * Returns true when the app is already running in standalone (installed PWA) mode.
 * iOS Safari uses the non-standard `navigator.standalone` boolean.
 */
export function isStandaloneDisplayMode(): boolean {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (navigator as any).standalone === true
  );
}
